import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { WithdrawalUpdateRequest } from "@/api/models/withdrawal/WithdrawalUpdateRequest";
import { ListRequest } from "@/api/models/ListRequest";
import { WithdrawalListResponse } from "@/api/models/withdrawal/WithdrawalListResponse";

export class WithdrawalService {
  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/withdrawal",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/withdrawal/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: WithdrawalUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/withdrawal",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<WithdrawalListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/withdrawal",
      body: body,
    });
  }
}
